module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/EndOfEmpire_Key-Art.779ac4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/EndOfEmpire_Key-Art.jpg
// module id = JfTM
// module chunks = 0